module.exports = __webpack_public_path__ + "media/images/design/common/images/cmn_link_rss-3d0f5898d75aebbe38660fed5e28328a.png";